export default __webpack_public_path__ + "static/media/iain.faae4a46.mp3";